export default {
  title: "Смена пароля",
  newPassword: "Новый пароль",
  submit: "Отправить",
  errorMessage: "Не удалось сменить пароль"
};
